import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiDataService } from "src/app/api/services/api-data.service";
import { CrewDetail } from "../models/crew-detail.interface";

@Injectable()
export class CrewService {

    private service = inject(ApiDataService);

    /**
     * Gets the crew detail by number
     * @param crewNumber the number of crew
     * @returns the detail of desired crew
     */
    public getDetail(crewNumber: number): Observable<CrewDetail> {
        return this.service.get<CrewDetail>('crews/get/' + crewNumber);
    }
}